import { rosterAPI } from '@/providers/apis/roster/roster';
import { Vue, Component } from 'vue-property-decorator';

@Component({
    name: 'courses-details',
})

export default class CoursesDetails extends Vue {

    // ------------------------------------------------------------------------
    // Properties
    private  filter: any = null;

    private courseDetails: any = [];


    // ----------------------------------------------------------------------
    // Hooks

}
